<template>
  <div class="login-page">
    <!-- 左侧品牌展示区 -->
    <div class="brand-section">
      <div class="brand-content">
        <!-- <img class="brand-logo" src="../../../assets/image/logo.png" alt="Logo"> -->
        <h1 class="brand-title">智慧课程<br>后台管理系统</h1>
        <p class="brand-subtitle">高效管理 · 智慧教学</p>
      </div>
    </div>

    <!-- 右侧登录表单区 -->
    <div class="login-section">
      <div class="login-card">
        <div class="login-header">
          <h2 class="login-title">欢迎登录</h2>
          <p class="login-desc">请使用您的账号登录系统</p>
        </div>

        <div class="login-form">
          <div class="form-item">
            <el-input
              prefix-icon="el-icon-phone-outline"
              v-model="username"
              placeholder="请输入手机号"
              class="custom-input">
            </el-input>
          </div>
          <div class="form-item">
            <el-input
              prefix-icon="el-icon-lock"
              v-model="password"
              placeholder="请输入密码"
              show-password
              class="custom-input"
              @keyup.enter.native="login">
            </el-input>
          </div>
        </div>

        <el-button class="login-btn" type="primary" @click="login()">登 录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {login,getUser} from '../../../api/api'
  import { setLock } from '@/utils/lock'
  export default {
    data() {
      return{
        username: '',
        password: ''
      }
    },
    methods: {
        login() {
            if(!this.username) {
                this.$message({
                    message: '请输入手机号',
                    type: 'warning'
                });
                return;
            }
            if(!this.password) {
                this.$message({
                    message: '请输入密码',
                    type: 'warning'
                });
                return;
            }
            var params = {
                phone: this.username,
                password: this.password
            }
            login(params).then(res => {
                if(res.code == 1000) {
                    this.$message({
                        message: '登录成功',
                        type: 'success'
                    });
                    var that = this
                    var token = res.data.token
                    this.$store.commit('user/setToken', token)
                    this.getUserInfo()
                    setLock(false)
                    setTimeout(function() {
                        that.$router.push("/index")
                    },500)
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        getUserInfo() {
            getUser().then(res => {
                if(res.code == 1000) {
                    this.$store.commit('user/setUser', JSON.stringify(res.data))
                }
            })
        },
    },
    created() {

    },
    mounted() {

    }
 }
</script>

<style scoped>
  .login-page {
    width: 100%;
    height: 100vh;
    display: flex;
    overflow: hidden;
  }

  /* 左侧品牌展示区 */
  .brand-section {
    flex: 1;
    background: linear-gradient(135deg, #0f1d3d 0%, #1a2a4a 50%, #2d4a6f 100%);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .brand-content {
    position: relative;
    z-index: 2;
    text-align: center;
    color: #ffffff;
    animation: fadeInLeft 0.8s ease-out;
  }

  .brand-logo {
    width: 80px;
    height: 80px;
    margin-bottom: 32px;
    object-fit: contain;
  }

  .brand-title {
    font-size: 36px;
    font-weight: 600;
    margin: 0 0 16px 0;
    line-height: 1.4;
    letter-spacing: 2px;
  }

  .brand-subtitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
    letter-spacing: 4px;
    font-weight: 300;
  }

  /* 右侧登录表单区 */
  .login-section {
    flex: 1;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .login-card {
    width: 420px;
    background: #ffffff;
    border-radius: 8px;
    padding: 48px 40px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
    animation: fadeInRight 0.8s ease-out;
  }

  .login-header {
    margin-bottom: 40px;
    text-align: center;
  }

  .login-title {
    font-size: 28px;
    font-weight: 600;
    color: #0f1d3d;
    margin: 0 0 12px 0;
    letter-spacing: 1px;
  }

  .login-desc {
    font-size: 14px;
    color: #909399;
    margin: 0;
  }

  .login-form {
    margin-bottom: 32px;
  }

  .form-item {
    margin-bottom: 20px;
  }

  .form-item:last-child {
    margin-bottom: 0;
  }

  /* 自定义输入框样式 */
  .custom-input ::v-deep .el-input__inner {
    height: 48px;
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    background-color: #f5f7fa;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .custom-input ::v-deep .el-input__inner:focus {
    border-color: #0f1d3d;
    background-color: #ffffff;
    box-shadow: 0 0 0 2px rgba(15, 29, 61, 0.1);
  }

  .custom-input ::v-deep .el-input__prefix {
    left: 14px;
  }

  .custom-input ::v-deep .el-input__inner {
    padding-left: 40px;
  }

  .custom-input ::v-deep .el-input__icon {
    color: #909399;
    font-size: 16px;
  }

  /* 登录按钮样式 */
  .login-btn {
    width: 100%;
    height: 48px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 2px;
    background: linear-gradient(135deg, #0f1d3d 0%, #1a2a4a 100%);
    border: none;
    transition: all 0.3s ease;
    user-select: none;
  }

  .login-btn:hover {
    background: linear-gradient(135deg, #1a2a4a 0%, #2d4a6f 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(15, 29, 61, 0.3);
  }

  .login-btn:active {
    transform: translateY(0);
  }

  /* 动画定义 */
  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  /* 响应式设计 */
  @media screen and (max-width: 1200px) {
    .brand-section {
      flex: 0.8;
    }

    .login-section {
      flex: 1;
    }
  }

  @media screen and (max-width: 768px) {
    .brand-section {
      display: none;
    }

    .login-section {
      flex: 1;
      background: linear-gradient(135deg, #0f1d3d 0%, #1a2a4a 100%);
    }

    .login-card {
      width: 90%;
      max-width: 400px;
      background: rgba(255, 255, 255, 0.98);
    }

    .login-title {
      color: #0f1d3d;
    }
  }
</style>
